var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12L10.5 9V15L15 12Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.9997C2.25 14.7934 2.54062 16.4247 2.75625 17.2684C2.81571 17.4974 2.92813 17.7091 3.08447 17.8866C3.2408 18.0641 3.43666 18.2024 3.65625 18.2903C6.79688 19.4903 12 19.4622 12 19.4622C12 19.4622 17.2031 19.4903 20.3438 18.2903C20.5633 18.2024 20.7592 18.0641 20.9155 17.8866C21.0719 17.7091 21.1843 17.4974 21.2438 17.2684C21.4594 16.4247 21.75 14.7934 21.75 11.9997C21.75 9.20592 21.4594 7.57467 21.2438 6.73092C21.1843 6.50198 21.0719 6.29022 20.9155 6.11272C20.7592 5.93522 20.5633 5.79694 20.3438 5.70904C17.2031 4.50904 12 4.53717 12 4.53717C12 4.53717 6.79688 4.50904 3.65625 5.70904C3.43666 5.79694 3.2408 5.93522 3.08447 6.11272C2.92813 6.29022 2.81571 6.50198 2.75625 6.73092C2.54062 7.57467 2.25 9.20592 2.25 11.9997Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_5589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.76ada9f72985138375ac3f445acccfcf.svg";
export { ForwardRef as ReactComponent };